module.exports = __webpack_public_path__ + "static/media/IconDel.e95f653e.svg";